import 'slick-carousel';
import '../../scss/slick.scss';

export default {
    initDesktop() {
        const sections = document.querySelectorAll('.specialties-shortcode--desktop');

        if (!sections.length) {
            return;
        }

        sections.forEach((section) => {
            section.addEventListener('click', (event) => {
                const image = event.target.closest('.speciality-item__icon img');

                if (!image || !section.contains(image)) {
                    return;
                }

                const currentItem = image.closest('.speciality-item');

                if (!currentItem) {
                    return;
                }

                section.querySelectorAll('.speciality-item').forEach((item) => {
                    item.classList.remove('speciality-item--active');
                });

                currentItem.classList.add('speciality-item--active');
            });
        });
    },

    initMobile() {
        const sections = document.querySelectorAll('.specialties-shortcode--mobile');

        if (!sections.length || typeof window.jQuery === 'undefined' || !window.jQuery.fn || !window.jQuery.fn.slick) {
            return;
        }

        sections.forEach((section) => {
            const $section = window.jQuery(section);

            if ($section.hasClass('slick-initialized')) {
                return;
            }

            const totalSlides = section.querySelectorAll('.speciality-item').length;
            const $controls = window.jQuery(`
                <div class="specialities-mobile-controls" aria-label="Carousel navigation">
                    <a href="#" class="specialities-mobile-controls__arrow specialities-mobile-controls__arrow--prev" aria-label="Previous slide">&lt;</a>
                    <span class="specialities-mobile-controls__indicator">1/${totalSlides}</span>
                    <a href="#" class="specialities-mobile-controls__arrow specialities-mobile-controls__arrow--next" aria-label="Next slide">&gt;</a>
                </div>
            `);

            $section.after($controls);

            $section.on('init reInit afterChange', (_, slick, currentSlide) => {
                const currentIndex = (typeof currentSlide === 'number' ? currentSlide : 0) + 1;

                $controls.find('.specialities-mobile-controls__indicator').text(`${currentIndex}/${slick.slideCount}`);
            });

            $section.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                dots: false,
                adaptiveHeight: false,
                prevArrow: $controls.find('.specialities-mobile-controls__arrow--prev'),
                nextArrow: $controls.find('.specialities-mobile-controls__arrow--next'),
            });
        });
    },

    finalize() {
        // No post-init behavior needed.
    },
};
